import React from 'react'
import SettingsIcon from '@mui/icons-material/Settings';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import StorageIcon from '@mui/icons-material/Storage';
import TableChartIcon from '@mui/icons-material/TableChart';
import { doesThisUserHaveThisAuthorization } from '../utilities/helperFunctions'

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}
function TabPanel(props) {
    const {
        children, value, index, ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    );
}

class Admin extends React.Component {
    state = {
        customerID: "",
        value: 0,
        expandedDbNodes: {},   // { [dbId]: true/false }
        expandedDsNodes: {},   // { ["dbId:dataSourceName"]: true/false }
        expandedMeasureNodes: {}, // { ["dbId:dataSourceName"]: true/false }
        dbNodeChildren: {},    // { [dbId]: [{ name, dimensions: [...], measures: [...] }, ...] }
        dbNodeLoading: {},     // { [dbId]: true/false }
        dbNodeErrors: {}       // { [dbId]: "error message" }
    }

    componentDidMount() {
        let filter = this.getAdminFilter(this.props.userFilter)
        this.setState({ value: filter["value"] })
        this.handleFilters(filter["label"])

        if (this.props.currentUser === null) {
            this.props.getCurrentUser(this.props.userID);
        }
    }

    getAdminFilter(filter) {

        let rtnVal = {
            "value": 0,
            "label": "ALL USERS"
        }

        if (filter) {
            let split = filter.split('|')

            if (split.length >= 2) {
                let filterValue = split[1]

                if (filterValue === "FOLDERS") {
                    rtnVal["value"] = 1
                    rtnVal["label"] = "FOLDERS"
                } else if (filterValue === "DATABASES") {
                    rtnVal["value"] = 2
                    rtnVal["label"] = "DATABASES"
                }
            }
        }

        return rtnVal;
    }

    handleFilters = (name) => {
        // event.preventDefault()
        let filterTerm = "filter|" + name
        this.props.applyFilter(filterTerm, "admin")
    }

    handleChangeForm = (event, newValue) => {
        this.setState({ value: newValue })
        this.handleFilters(newValue === 0 ? 'ALL USERS' : newValue === 1 ? "FOLDERS" : "DATABASES")

    };

    deleteUser = (id) => {
        this.props.showPopup("deleteUser", id)
    }

    editUser = (id, role) => {
        this.props.showPopup("editUser", [id, role])
    }

    handleAddUser = (event) => {
        event.preventDefault();
        this.props.showPopup("addUser", this.props.customerList);
    }

    handleAddCustomer = () => {
        this.props.showPopup("addCustomer")
    }

    handleAddTeam = () => {
        this.props.showPopup("addTeam", this.props.customerList)
    }

    handleEditTeam = () => {
        this.props.showPopup("editTeam")
    }

    deleteFolder = (id) => {
        this.props.showPopup("deleteFolder", id)
    }

    handleEditFolder = (folderId) => {
        this.props.showPopup("addeditFolder", folderId)
    }

    handleAddFolder = (event) => {

        this.props.showPopup("addeditFolder", null)
        event.preventDefault()
    }

    deleteDatabase = (id) => {
        this.props.showPopup("deleteDatabase", id)
    }

    handleEditDatabase = (dbId) => {
        this.props.showPopup("addeditDatabase", dbId)
    }

    handleAddDatabase = (event) => {
        this.props.showPopup("addeditDatabase", null)
        event.preventDefault()
    }

    handleCreateDatabase = (event) => {
        this.props.showPopup("createDatabase", null)
        event.preventDefault()
    }

    handleDBupload = () => {
        this.props.showPopup("DBupload")
    }

    handleLogoUpload = () => {
        this.props.showPopup("WebUpload")
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }

    handleResetUserPassword = (id) => {
        if (id) {
            this.props.showPopup("resetPassword", id)
        }

    }

    openNewDatabaseFunctions = (event) => {
        let dbFunctionsWindow = window.open("/databasefunctions")
        event.preventDefault()
    }

    displayUsersHead = () => {
        if (this.props.userList !== null) {
            return (<TableHead>
                <TableRow>
                    <TableCell>Login</TableCell>
                    <TableCell align="right">Name</TableCell>
                    <TableCell align="right">Customer</TableCell>
                    <TableCell align="right">Role</TableCell>
                    <TableCell align="right">Teams</TableCell>
                    <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>)
        } else {
            return null
        }
    }

    generateUserList = () => {
        let list = (this.state.customerID === "") ? this.props.userList : this.props.userList.filter(x => x.customerID === parseInt(this.state.customerID))
        if (!this.props.userFilter.includes("filter|")) {
            list = list.filter(x => x.userName.toLowerCase().includes(this.props.userFilter.toLowerCase()))
        }

        // Customer Users, under ALL USERS tab should only see themselves and only be able to change password.
        if (this.props.role === "Builder" && this.props.currentUser) {
            list = list.filter(x => x.userName.toLowerCase() === this.props.currentUser.userName.toLowerCase())
        }

        return (list.map((x, i) =>
            <TableRow key={x.id}>
                <TableCell>{x.userName}</TableCell>
                <TableCell align="right">
                    {x.firstName}
                    {' '}
                    {x.lastName}
                </TableCell>
                <TableCell align="right">{x.customer.name}</TableCell>
                <TableCell align="right">
                    {x.applicationUserRoles !== null
                        ? x.applicationUserRoles
                            .map((_row) => _row.role.name)
                            .toString()
                        : ''}
                </TableCell>
                <TableCell align="right">
                    {x.applicationUserTeams !== null
                        ? x.applicationUserTeams
                            .map((_row) => _row.team.name)
                            .toString()
                        : ''}
                </TableCell>
                <TableCell align="right">
                    {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin" || this.props.role === "Builder") && <IconButton
                        onClick={() => this.handleResetUserPassword(x.id)}>
                        <LockOpenIcon />
                    </IconButton>}
                    {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <IconButton onClick={() => this.editUser(x.id, x.role)}>
                        <EditIcon />
                    </IconButton>}
                    {(x.role !== "IEAdmin") && (this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <IconButton
                        onClick={(e) => {
                            this.deleteUser(x.id);
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>}
                </TableCell>
            </TableRow>

        ))
    }

    displayFolderHead = () => {
        if (this.props.folderList !== null) {
            return (<TableHead>
                <TableRow>
                    <TableCell>Customer</TableCell>
                    <TableCell>Folder Name</TableCell>
                    <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>)
        } else {
            return null
        }
    }

    generateFolderList = () => {
        let list = (this.state.customerID === "") ? this.props.folderList : this.props.folderList.filter(x => x.customerID === parseInt(this.state.customerID))

        return (list.map((x, i) =>
            <TableRow key={x.id}>
                <TableCell>{x.customerName}</TableCell>
                <TableCell>{x.folderName}</TableCell>
                <TableCell align="right">
                    <IconButton onClick={() => this.handleEditFolder(x.id, x.folderName)}>
                        <EditIcon />
                    </IconButton>
                    <IconButton
                        onClick={(e) => {
                            this.deleteFolder(x.id);
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            </TableRow>

        ))
    }

    toggleDatabaseNode = (dbId) => {
        const isExpanded = !!this.state.expandedDbNodes[dbId];

        this.setState((prevState) => ({
            expandedDbNodes: { ...prevState.expandedDbNodes, [dbId]: !isExpanded }
        }));

        // Fetch children on first expand only (results are cached afterwards)
        if (!isExpanded && this.state.dbNodeChildren[dbId] === undefined && !this.state.dbNodeLoading[dbId]) {
            this.fetchDataSources(dbId);
        }
    }

    fetchDataSources = (dbId) => {
        this.setState((prevState) => ({
            dbNodeLoading: { ...prevState.dbNodeLoading, [dbId]: true },
            dbNodeErrors: { ...prevState.dbNodeErrors, [dbId]: null }
        }));

        fetch(`${process.env.REACT_APP_BACK_URL}/admin/datasourcesinfo/${dbId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Request failed (${response.status})`);
                }
                return response.json();
            })
            .then((data) => {
                // API returns a dictionary: { "<dataSourceName>": { dimensions: [ { dimensionName, dimensionAlias, itemsCount, segmentCount, type }, ... ], measures: [...] }, ... }
                // Convert it to an array of datasource nodes for rendering.
                const children = Object.entries(data || {}).map(([name, info]) => ({
                    name: name,
                    dimensions: (info && info.dimensions) || [],
                    measures: (info && info.measures) || []
                }));

                this.setState((prevState) => ({
                    dbNodeChildren: { ...prevState.dbNodeChildren, [dbId]: children },
                    dbNodeLoading: { ...prevState.dbNodeLoading, [dbId]: false }
                }));
            })
            .catch((error) => {
                this.setState((prevState) => ({
                    dbNodeLoading: { ...prevState.dbNodeLoading, [dbId]: false },
                    dbNodeErrors: { ...prevState.dbNodeErrors, [dbId]: error.message }
                }));
            });
    }

    displayDBHead = () => {
        if (this.props.databaseList !== null) {
            return (<TableHead>
                <TableRow>
                    <TableCell style={{ width: 72, padding: '0 4px' }} />
                    <TableCell>Customer</TableCell>
                    <TableCell>Server Type</TableCell>
                    <TableCell>Server</TableCell>
                    <TableCell>Database</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>)
        } else {
            return null
        }
    }

    toggleDataSourceNode = (dbId, dsName) => {
        const nodeKey = `${dbId}:${dsName}`;
        this.setState((prevState) => ({
            expandedDsNodes: { ...prevState.expandedDsNodes, [nodeKey]: !prevState.expandedDsNodes[nodeKey] }
        }));
    }

    toggleMeasuresNode = (dbId, dsName) => {
        const nodeKey = `${dbId}:${dsName}`;
        this.setState((prevState) => ({
            expandedMeasureNodes: { ...prevState.expandedMeasureNodes, [nodeKey]: !prevState.expandedMeasureNodes[nodeKey] }
        }));
    }

    renderDimensionsTable = (dimensions) => {
        return (
            <Table size="small" className="nestedInfoTable" sx={{ ml: '100px', mb: 1, width: 'auto', minWidth: 480 }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Dimension</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Item Count</TableCell>
                        <TableCell>Segment Count</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dimensions.map((d, i) => (
                        <TableRow key={i}>
                            <TableCell>{d.dimensionName}</TableCell>
                            <TableCell>{d.type}</TableCell>
                            <TableCell>{d.itemsCount}</TableCell>
                            <TableCell>{d.segmentCount}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    renderMeasuresNode = (dbId, ds) => {
        const nodeKey = `${dbId}:${ds.name}`;
        const isMeasuresExpanded = !!this.state.expandedMeasureNodes[nodeKey];
        const measures = ds.measures || [];

        return (
            <Table size="small" className="nestedInfoTable" sx={{ ml: '100px', mb: 1, width: 'auto', minWidth: 480 }}>
                <TableHead>
                    <TableRow
                        sx={{ cursor: 'pointer' }}
                        onClick={() => this.toggleMeasuresNode(dbId, ds.name)}
                    >
                        <TableCell>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {isMeasuresExpanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                                Measures
                            </div>
                        </TableCell>
                    </TableRow>
                </TableHead>
                {isMeasuresExpanded && (
                    <TableBody>
                        {measures.length === 0
                            ? (
                                <TableRow>
                                    <TableCell>No measures found</TableCell>
                                </TableRow>
                            )
                            : measures.map((m, i) => (
                                <TableRow key={i}>
                                    <TableCell>{m}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                )}
            </Table>
        );
    }

    renderDBNodeChildren = (dbId) => {
        const isLoading = this.state.dbNodeLoading[dbId];
        const error = this.state.dbNodeErrors[dbId];
        const children = this.state.dbNodeChildren[dbId];

        if (isLoading) {
            return (
                <ListItem sx={{ pl: '50px', py: '5px' }}>
                    <CircularProgress size={16} sx={{ mr: 1 }} />
                    <ListItemText secondary="Loading data sources..." sx={{ my: 0 }} />
                </ListItem>
            );
        }

        if (error) {
            return (
                <ListItem sx={{ pl: '50px', py: '5px' }}>
                    <ListItemText
                        secondary={`Failed to load data sources: ${error}`}
                        secondaryTypographyProps={{ color: 'error' }}
                        sx={{ my: 0 }}
                    />
                    <button className="btn" onClick={() => this.fetchDataSources(dbId)}>Retry</button>
                </ListItem>
            );
        }

        if (children && children.length === 0) {
            return (
                <ListItem sx={{ pl: '50px', py: '5px' }}>
                    <ListItemText secondary="No data sources found" sx={{ my: 0 }} />
                </ListItem>
            );
        }

        return (children || []).map((ds) => {
            const nodeKey = `${dbId}:${ds.name}`;
            const isDsExpanded = !!this.state.expandedDsNodes[nodeKey];

            return (
                <React.Fragment key={nodeKey}>
                    <ListItem
                        sx={{ pl: '50px', py: '5px', cursor: 'pointer' }}
                        onClick={() => this.toggleDataSourceNode(dbId, ds.name)}
                    >
                        <ListItemIcon sx={{ minWidth: 20 }}>
                            {isDsExpanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                        </ListItemIcon>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <TableChartIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={ds.name} sx={{ my: 0 }} primaryTypographyProps={{ fontSize: 15 }} />
                    </ListItem>
                    <Collapse in={isDsExpanded} timeout="auto" unmountOnExit>
                        {this.renderDimensionsTable(ds.dimensions)}
                        {this.renderMeasuresNode(dbId, ds)}
                    </Collapse>
                </React.Fragment>
            );
        });
    }

    generateDBList = () => {
        let list = (this.state.customerID === "") ? this.props.databaseList : this.props.databaseList.filter(x => x.customerID === parseInt(this.state.customerID))

        return (list.map((x) => {
            const isExpanded = !!this.state.expandedDbNodes[x.id];

            return (
                <React.Fragment key={x.id}>
                    <TableRow>
                        <TableCell>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton sx={{ p: '2px' }} size="small" onClick={() => this.toggleDatabaseNode(x.id)}>
                                    {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                                </IconButton>
                                <StorageIcon fontSize="small" />
                            </div>
                        </TableCell>
                        <TableCell>{x.customerName}</TableCell>
                        <TableCell>{x.serverType == 0 ? "SQL" : "SSAS"}</TableCell>
                        <TableCell>{x.server}</TableCell>
                        <TableCell>{x.dBname}</TableCell>
                        <TableCell>{x.userName}</TableCell>
                        <TableCell align="right">
                            <IconButton size="small" onClick={() => this.handleEditDatabase(x.id, x.Server)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton size="small"
                                onClick={(e) => {
                                    this.deleteDatabase(x.id);
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                    {isExpanded &&
                        <TableRow>
                            <TableCell style={{ padding: 0 }} colSpan={7}>
                                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {this.renderDBNodeChildren(x.id)}
                                    </List>
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    }
                </React.Fragment>
            );
        }))
    }

    render() {
        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <h2 className="pageHead">
                            <SettingsIcon />
                            {' '}
                            Admin
                            <div className="rightButton">
                                {(this.props.role === "IEAdmin") && <button className="btn" onClick={this.handleAddUser} id="adduser_btn">Add User</button>}
                                {(this.props.role === "IEAdmin") && <button className="btn" onClick={this.handleAddCustomer} id="addcustomer_btn">Add Customer</button>}
                                {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <button className="btn" onClick={this.handleAddTeam} id="addteam_btn">Add Team</button>}
                                {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <button className="btn" onClick={this.handleEditTeam} id="editteam_btn">Edit Team</button>}
                                {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <button className="btn" onClick={this.handleCreateDatabase} id="createdatabase_btn">Create Database</button>}
                                {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <button className="btn" onClick={this.handleAddDatabase} id="adddatabase_btn">Add Database</button>}
                                {(this.props.role === "Builder" || this.props.role === "ClientAdmin" || this.props.role === "IEAdmin") && <button className="btn" onClick={this.handleAddFolder} id="addfolder_btn">Add Folder</button>}
                                {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <button className="btn" onClick={this.handleLogoUpload} id="logoupload_btn">Logo Upload</button>}
                            </div>
                        </h2>
                        <div className="tabOutMain">
                            <AppBar position="static">
                                <Tabs value={this.state.value} onChange={this.handleChangeForm}>
                                    <Tab label="All Users" {...a11yProps(0)} />
                                    <Tab label="Folders" {...a11yProps(1)} />
                                    {(this.props.role === "IEAdmin" || this.props.role === "ClientAdmin") && <Tab label="Databases" {...a11yProps(2)} />}

                                    <div className="rightButtonSelect">
                                        <Select
                                            defaultValue=""
                                            onChange={this.handleCustomerID}
                                            value={this.state.customerID}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Without label' }}
                                        >
                                            <MenuItem value="">
                                                {(this.state.customerID === "") ? "Filter by Customer" : "All Customers"}
                                            </MenuItem>
                                            {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                                        </Select>
                                    </div>
                                </Tabs>
                            </AppBar>
                            <TabPanel value={this.state.value} index={0}>

                                <Table aria-label="users">
                                    {this.displayUsersHead()}
                                    <TableBody>
                                        {this.generateUserList()}
                                    </TableBody>
                                </Table>

                            </TabPanel>

                            <TabPanel value={this.state.value} index={1}>

                                <Table aria-label="folders">
                                    {this.displayFolderHead()}
                                    <TableBody>
                                        {this.generateFolderList()}
                                    </TableBody>
                                </Table>

                            </TabPanel>

                            <TabPanel value={this.state.value} index={2}>

                                <Table aria-label="databases">
                                    {this.displayDBHead()}
                                    <TableBody>
                                        {this.generateDBList()}
                                    </TableBody>
                                </Table>

                            </TabPanel>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


export default Admin